import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountAccessService } from '@modules/navigation/services';
import { AuthService } from '@modules/auth/services';
import { LoggingService } from '@app/core/services/logging.service';

const LOGIN_ROUTE = '/auth/login';

@Component({
    selector: 'app-signin-callback',
    template: `<div></div>`,
})
export class SigninRedirectCallbackComponent implements OnInit {
    private readonly loggingService = inject(LoggingService);
    constructor(
        private readonly _authService: AuthService,
        private readonly _router: Router,
        private readonly accountAccessService: AccountAccessService
    ) {}

    async ngOnInit(): Promise<void> {
        try {
            await this._authService.completeLogin();
            await this._router.navigateByUrl(this.accountAccessService.getDefaultRoute(), {
                replaceUrl: true,
            });
        } catch (error) {
            this.loggingService.error('[SigninRedirectCallback] Login callback failed.', error);
            // Authentication failures must land on an unguarded route. Sending
            // them under /main invokes AuthGuard and starts another refresh flow.
            await this._router.navigateByUrl(LOGIN_ROUTE, { replaceUrl: true });
        }
    }
}
